import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Dispatch,
    MutableRefObject,
    SetStateAction,
    useCallback,
    useEffect,
    useState,
} from "react";
import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../Context/User";
import {
    CalculaDescontoJurosMultaController,
    GetMelhorAlcadaDescontoController,
    VerificaNrAgingAlcadaController,
} from "../../../Controllers/Cobranca/AlcadaDesconto/AlcadaDescontoController";
import { IAcadaDesconto } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import SpinnerComponent from "../../Loding/Spinner";

interface IDescontoAlcadaProps {
    ID_CASO?: number;
    ID_CONTA: number;
    lstParcelasBoletosRequest: Array<IParcelaBoletos>;
    setPorcentagemJuros: Dispatch<SetStateAction<number>>;
    setPorcentagemMulta: Dispatch<SetStateAction<number>>;
    bloqueioDescontoAlcada: boolean;
    setBloqueioHonorario: Dispatch<SetStateAction<boolean>>;

    setDesconto: (desconto: { MULTA: number; JUROS: number }) => void;
    porcentagemHonorarioSaved: MutableRefObject<number>;
    porcentagemHonorario: number;
    porcentagemJuros?: number;
    porcentagemMulta?: number;

    desconto: {
        MULTA: number;
        JUROS: number;
    };
}

interface IDesconto {
    NUM_PERCENTUAL_JUROS: number;
    NUM_PERCENTUAL_MULTA: number;
    NUM_PERCENTUAL_HONORARIO: number;
}
export function DescontoAlcada(props: IDescontoAlcadaProps) {
    const [MelhorAlcada, setMelhorAlcada] = useState<IAcadaDesconto>();
    const [FLNrAging, setFLNrAging] = useState<boolean>();

    const [aplicandoDesconto, setAplicandoDesconto] = useState(false);

    const { Config } = useUserInfor();
    const { register, handleSubmit, formState, reset } = useForm();

    const {
        lstParcelasBoletosRequest,
        ID_CASO,
        setDesconto,
        porcentagemHonorario,
        setBloqueioHonorario,
        setPorcentagemMulta,
        setPorcentagemJuros,
        porcentagemMulta,
        porcentagemJuros,
    } = props;

    useEffect(() => {
        if (props.ID_CASO && Config.ConfigCobrancaDTO.FL_ALCADAS_DESCONTO) {
            GetMelhorAlcadaDescontoController(props.ID_CASO).then((res) => {
                setMelhorAlcada(res);

                if (
                    props.ID_CASO &&
                    res.NR_FIM_AGING !== undefined &&
                    res.NR_INICIO_AGING !== undefined
                )
                    VerificaNrAgingAlcadaController(
                        res.NR_INICIO_AGING,
                        res.NR_FIM_AGING,
                        props.ID_CONTA,
                        props.ID_CASO
                    ).then((res) => {
                        setFLNrAging(res);
                    });
            });
        }
    }, [
        Config.ConfigCobrancaDTO.FL_ALCADAS_DESCONTO,
        props.ID_CASO,
        props.ID_CONTA,
    ]);

    const handleDescontoFormSubmit = useCallback(
        (formData: IDesconto) => {
            setAplicandoDesconto(true);
            setBloqueioHonorario(false);
            if (porcentagemHonorario > 0) {
                props.porcentagemHonorarioSaved.current = porcentagemHonorario;
            }
            if (
                ID_CASO &&
                lstParcelasBoletosRequest.length > 0 &&
                aplicandoDesconto
            )
                CalculaDescontoJurosMultaController(
                    lstParcelasBoletosRequest,
                    ID_CASO,
                    porcentagemJuros ?? 0,
                    porcentagemMulta ?? 0,
                    porcentagemHonorario ?? 0
                ).then((res) => {
                    setDesconto({
                        MULTA: res.MULTA,
                        JUROS: res.JUROS,
                    });
                });
            else setDesconto({ MULTA: 0, JUROS: 0 });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            lstParcelasBoletosRequest,
            ID_CASO,
            setDesconto,
            aplicandoDesconto,
            porcentagemHonorario,
            setBloqueioHonorario,
            porcentagemJuros,
            porcentagemMulta,
        ]
    );

    useEffect(() => {
        if (lstParcelasBoletosRequest.length > 0 && aplicandoDesconto)
            handleSubmit(handleDescontoFormSubmit)();
        else setDesconto({ MULTA: 0, JUROS: 0 });
    }, [
        handleSubmit,
        lstParcelasBoletosRequest,
        aplicandoDesconto,
        handleDescontoFormSubmit,
        setDesconto,
        props.desconto.JUROS,
        props.desconto.MULTA,
    ]);

    return MelhorAlcada ? (
        <>
            <>
                <div
                    id="accordion"
                    className="card card-custom w-auto ml-auto wave wave-animate-slow wave-danger border-bottom border-1 border-dark"
                >
                    <div className="card-header p-1">
                        <div id="headingOne">
                            <h5 className="mb-0">
                                <button
                                    className="btn btn-link text-decoration-none"
                                    data-toggle="collapse"
                                    data-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    <div className="d-flex flex-wrap justify-content-between m-1 align-items-center">
                                        <h2 className="p-0 m-0">
                                            PORCENTAGEM DE DESCONTO
                                            <FontAwesomeIcon
                                                icon={faArrowCircleDown}
                                                className="ml-1 mr-1"
                                            />
                                        </h2>
                                    </div>
                                </button>
                            </h5>
                        </div>
                    </div>

                    <div
                        id="collapseOne"
                        className="panel-collapse collapse p-3"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                    >
                        <div className="d-flex flex-wrap justify-content-between mb-5">
                            {MelhorAlcada.NUM_MINIMO_PARCELAS === 0 ? (
                                <div>
                                    Não existe um número mínimo de parcelas a
                                    serem selecionadas para aplicar o desconto.
                                </div>
                            ) : (
                                <div>
                                    <strong>
                                        Para aplicar o desconto é necessário
                                        selecionar{" "}
                                        {MelhorAlcada.NUM_MINIMO_PARCELAS}{" "}
                                        parcela
                                        {MelhorAlcada.NUM_MINIMO_PARCELAS > 1
                                            ? "s"
                                            : ""}{" "}
                                        no mínimo.
                                    </strong>
                                </div>
                            )}
                            {FLNrAging ? (
                                <form
                                    id="formAlçada"
                                    onSubmit={handleSubmit(
                                        handleDescontoFormSubmit
                                    )}
                                    className="w-100 align-itens-center d-flex flex-wrap justify-content-between mt-3"
                                >
                                    <div className="d-flex flex-row align-items-end">
                                        <div>
                                            <label htmlFor="NUM_PERCENTUAL_JUROS">
                                                {" "}
                                                Multa:{" "}
                                            </label>
                                            <input
                                                type="number"
                                                name="NUM_PERCENTUAL_MULTA"
                                                placeholder={"Multa"}
                                                defaultValue={0}
                                                step={0.1}
                                                className={`form-control px-0 p-2 mr-3 w-100 placeholder-muted-75  ${
                                                    formState.errors
                                                        .NUM_PERCENTUAL_MULTA &&
                                                    "is-invalid"
                                                }`}
                                                ref={register({
                                                    min: 0,
                                                    max: MelhorAlcada.NUM_PERCENTUAL_MULTA,
                                                })}
                                                onChange={(e) =>
                                                    setPorcentagemMulta(
                                                        Number(e.target.value)
                                                    )
                                                }
                                                disabled={
                                                    (porcentagemHonorario > 0 ||
                                                        props.desconto.MULTA >
                                                            0) &&
                                                    props.desconto.JUROS > 0
                                                }
                                                onBlur={() => {
                                                    if (aplicandoDesconto)
                                                        handleSubmit(
                                                            handleDescontoFormSubmit
                                                        )();
                                                }}
                                                max={
                                                    MelhorAlcada.NUM_PERCENTUAL_MULTA
                                                }
                                            />
                                        </div>
                                        <span className="pb-3 ml-1">
                                            Percentual máximo de:{" "}
                                            {MelhorAlcada.NUM_PERCENTUAL_MULTA}%
                                        </span>
                                    </div>

                                    <div className="d-flex flex-row align-items-end">
                                        <div>
                                            <label htmlFor="NUM_PERCENTUAL_JUROS">
                                                {" "}
                                                Juros:{" "}
                                            </label>
                                            <input
                                                type="number"
                                                step={0.1}
                                                name="NUM_PERCENTUAL_JUROS"
                                                placeholder={"Juros"}
                                                className={`form-control px-0 p-2 mr-3 w-100 placeholder-muted-75  ${
                                                    formState.errors
                                                        .NUM_PERCENTUAL_MULTA &&
                                                    "is-invalid"
                                                }`}
                                                onChange={(e) =>
                                                    setPorcentagemJuros(
                                                        Number(e.target.value)
                                                    )
                                                }
                                                defaultValue={0}
                                                onBlur={() => {
                                                    if (aplicandoDesconto)
                                                        handleSubmit(
                                                            handleDescontoFormSubmit
                                                        )();
                                                }}
                                                disabled={
                                                    (porcentagemHonorario > 0 ||
                                                        props.desconto.JUROS >
                                                            0) &&
                                                    props.desconto.MULTA > 0
                                                }
                                                ref={register({
                                                    min: 0,
                                                    max: MelhorAlcada.NUM_PERCENTUAL_JUROS,
                                                })}
                                                max={
                                                    MelhorAlcada.NUM_PERCENTUAL_JUROS
                                                }
                                            />
                                        </div>
                                        <span className="pb-3 ml-1">
                                            Percentual máximo de:{" "}
                                            {MelhorAlcada.NUM_PERCENTUAL_JUROS}%
                                        </span>
                                    </div>

                                    <div>
                                        {!aplicandoDesconto ? (
                                            <span>
                                                <button
                                                    type="submit"
                                                    form="formAlçada"
                                                    className="btn btn-outline-primary font-weight-bold d-flex justify-content-center m-1"
                                                >
                                                    Aplicar Desconto
                                                </button>
                                            </span>
                                        ) : (
                                            <div>
                                                <button
                                                    type="button"
                                                    disabled={
                                                        props.bloqueioDescontoAlcada
                                                    }
                                                    onClick={() => {
                                                        props.setDesconto({
                                                            JUROS: 0,
                                                            MULTA: 0,
                                                        });
                                                        reset();
                                                        setAplicandoDesconto(
                                                            false
                                                        );
                                                        props.setBloqueioHonorario(
                                                            true
                                                        );
                                                        setPorcentagemJuros(0);
                                                        setPorcentagemMulta(0);
                                                    }}
                                                    className="btn btn-outline-danger font-weight-bold d-flex justify-content-center m-1"
                                                >
                                                    Remover Desconto
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </form>
                            ) : FLNrAging === false ? (
                                <div>
                                    Sua empresa está configurada para dar
                                    desconto por porcentagem na multa e juros.
                                    Esta obra possui uma alçada de desconto
                                    configurada para você, porém está fora da
                                    faixa de indadimplência cadastrada.
                                </div>
                            ) : (
                                <SpinnerComponent />
                            )}
                        </div>
                    </div>
                </div>
            </>
        </>
    ) : (
        <div>
            Sua empresa está configurada para dar desconto por porcentagem na
            multa e juros, porém, esta obra não possui uma alçada de desconto
            configurada para você.
        </div>
    );
}
